import PopulationSearch from "./PopulationSearch";
export default PopulationSearch;
